export default __webpack_public_path__ + "static/media/industry-types-icon.27d4032a.svg";